import { render, staticRenderFns } from "./navigation-card.vue?vue&type=template&id=86ff52a4&scoped=true&"
import script from "./navigation-card.vue?vue&type=script&lang=js&"
export * from "./navigation-card.vue?vue&type=script&lang=js&"
import style0 from "./navigation-card.vue?vue&type=style&index=0&id=86ff52a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ff52a4",
  null
  
)

export default component.exports